<template>
  <v-card
    flat
    tile
    :ripple="{ class: 'primary--text' }"
    class="d-flex justify-space-between align-center py-2 pl-4"
    @click="handleSwitch"
    @keydown.enter="handleSwitch"
  >
    <div class="d-flex align-center">
      <v-icon
        class="mr-4"
        color="icon-secondary"
      >
        ui-icon-rating-star-outline
      </v-icon>
      <div class="d-flex flex-column align-start">
        <div class="text-body-1 text--text">
          {{ t('Высокий рейтинг', options) }}
        </div>
        <div class="text-body-2 text-secondary--text">
          {{ t('С рейтингом выше 4.0', options) }}
        </div>
      </div>
    </div>
    <v-switch
      :value="filtersStore.unsavedFilters.isHighRating"
      :input-value="filtersStore.unsavedFilters.isHighRating"
      color="primary"
      class="pt-0 mt-0 pl-1"
      hide-details
      dense
      inset
      @input="emitChanges"
    />
  </v-card>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { computed, toRefs } from 'vue'
import useFiltersStore from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore'
import type { Filters } from 'www/vue_components/common/TheFilters/doctors/stores/useFiltersStore.types'

const emit = defineEmits(['input'])
const props = defineProps<{ value: Filters }>()
const { value: doctorFiltersState } = toRefs(props)

const { t, language } = I18NextVue
const options = computed(() => ({ ns: language }))

const filtersStore = useFiltersStore()

const emitChanges = (isEnabled: boolean) => {
  filtersStore.updateUnsavedFilters({
    isHighRating: isEnabled || undefined,
  })
  emit('input', {
    ...doctorFiltersState.value,
    isHighRating: isEnabled || undefined,
  })
}

const handleSwitch = () => {
  emitChanges(!filtersStore.unsavedFilters.isHighRating)
}
</script>
